module.exports = __webpack_public_path__ + "img/mx_subject.18e02e1b.png";